<template>
  <div v-if="bodyShow">
    <div v-if="banner" class="banner">
        <img :src="banner">
    </div>
    <div class="ms-receive">
        <img class="bg" src="@a/ms_system/receive_bg_ful.png" v-show="!banner" />
        <!-- 主题内容 -->
        <div class="ms-receive-content">
            <div class="header">
                <img  src="@a/ms_system/receive_left.png" />
                我的测评兑换码
                <img  src="@a/ms_system/receive_right.png" />
            </div>
            <!-- 兑换码 -->
            <h3 class="code">{{code}}</h3>
            <!-- 复制 -->
            <a v-clipboard:copy="code" v-clipboard:success="onCopy" v-clipboard:error="onError" class="copyBtn">复制</a>
            <div class="small"><span>*</span>此兑换码可用于以下测评套餐</div>
        </div>
        <!-- 测评商品 -->
        <div class="product-box">
            <img :src='product.image' />
            <!-- 右侧内容 -->
            <div class="right-text">
                <h4 class="title text-ellipsis">{{product.name}}</h4>
                <div class="text-ellipsis arr">
                    <span v-for="(item,index) in list">
                        {{item.name}}
                        <span v-if="index<list.length-1">,</span>
                    </span>
                </div>
                <div class="price">
                    {{product.discount_price/100}} 元
                    <div class="hr"></div>
                    {{product.buy_count}} 人
                    <router-link :to="{
                        path:'/ms_package_goods',
                        query:{
                            id:this.product_id,
                            code:this.code
                        }
                    }" class="btn">去测评</router-link>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import { get_present_code,detail } from "@/api/measurement_system";

export default {
  data() {
    return {
        bodyShow:false,
        code:'',
        banner: null,
        //   测评商品
        product:{},
        list:[]
    }
  },
  methods: {
    // 复制成功
    onCopy(e) {
        this.$toast('复制成功!');
    },
    // 复制失败
    onError(e) {
        this.$toast("复制失败，请长按上方兑换码复制！");
    },
    // 初始化获取测评兑换码
    pullData(){
        //调用加载中
        this.$emit('loadingHandle',true,"加载中...");
        get_present_code({
            activity_id:this.$route.query.activity_id
        }).then((data)=>{
            if (data.code == 10002) {
                this.$emit('loadingHandle',false);
                this.$dialog.alert({
                    title: '提示',
                    showConfirmButton:false,
                    message: data.data.msg
                });
                // this.$toast(data.data.msg);
                return;
            }

            document.title = '我的兑换码';
            this.code = data.code;
            this.banner = data.banner;
            this.product_id = data.product_id;

            detail({
                id:this.product_id || 14
            }).then((data)=>{
                if (data.code == 10002) {
                    this.$toast(data.data.msg);
                    return;
                }
                this.product = data.product;
                this.list = data.list;
            });

            this.bodyShow = true;
            //关闭加载中
            this.$emit('loadingHandle',false);
        });
    }
    
  },
  created() {
    // this.$dialog.alert({
    //     title: '提示',
    //     showConfirmButton:false,
    //     message: '本次活动已经结束了，下次早点来哟~'
    // });
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
div.title{
    font-size:34px;
    color:#fff;
}
.banner {
    width: 100%;
    img {
        width: 100%;
    }
}
.ms-receive{
    position:relative;
    padding:30px;
    .bg{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:150px;
        z-index:1;
    }
    .ms-receive-content{
        background-color: #fff;
        border-radius:12px;
        position: relative;
        z-index:2;
        padding:50px 30px 66px;
        margin-bottom:40px;
        .header{
            display:flex;
            font-size:34px;
            color:#EB5032;
            font-weight:bold;
            align-items: center;
            justify-content: space-between;
            margin-bottom:80px;
            letter-spacing: 2px;
            img{
                width:179px;
                height:18px;
            }
        }
        .code{
            font-size:68px;
            color:#333;
            margin-bottom:60px;
            text-align:center;
            -webkit-user-select: text !important;
            -khtml-user-select: text !important;
            -moz-user-select: text !important;
            -ms-user-select: text !important;
            user-select: text !important;
        }
        .copyBtn{
            display:block;
            background:#EB5032;
            color:#fff;
            border-radius:32px;
            line-height:64px;
            width:174px;
            text-align:center;
            margin:0 auto 20px;
            font-size:34px;
        }
        .small{
            font-size:24px;
            color:#999999;
            display: flex;
            justify-content: center;
            letter-spacing: 2px;
            span{
                color:#EB5032;
                padding-top:5px;
                margin-right:5px;
            }
        }
    }
    .product-box{
        padding:30px;
        background-color: #fff;
        display:flex;
        border-radius:12px;
        img{
            width:200px;
            height:150px;
            margin-right:20px;
        }
        .right-text{
            flex:1;
            
            h4.title{
                font-size:30px;
                color:#333333;
                font-weight:bold;
                line-height:40px;
                margin-bottom:15px;
                width:410px;
            }
            .arr{
                font-size:24px;
                color:#666666;
                text-align:left;
                width:410px;
                line-height:30px;
                margin-bottom:34px;
            }
            .price{
                font-size:24px;
                color:#EB5032;
                display:flex;
                align-items: center;
                div.hr{
                    width:2px;
                    height:21px;
                    margin:0 14px;
                    background-color:#EB5032;
                }
                .btn{
                    display:block;
                    width:134px;
                    line-height:48px;
                    font-size:24px;
                    color:#FFFFFF;
                    border-radius:24px;
                    margin-left:57px;
                    background-color:#EB5032;
                    text-align:center;
                    letter-spacing: 2px;
                }
            }
        }
    }
}
</style>